import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/outline";
import { ebaySearchString } from "../../../utils/ebaySearchString";
import openInNewTab from "../../../utils/openInNewTab";


export default function EbayLinkButton({ query }: { query: string }) {
  return (
    <div
      title="Search eBay"
      className="flex mt-2 min-w-14 max-w-16 px-2 gap-x-1 items-center cursor-pointer border rounded-full bg-slate-200 border-blue-400 hover:scale-105 transition-all"
      onClick={() => openInNewTab(ebaySearchString(query))}
    >
      <img src={`/ebayLogo.svg`} className="w-6 h-6" />
      <ArrowTopRightOnSquareIcon className="text-gray-600 w-3 h-3" />
    </div>
  )
}